import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  grid: {
    display: 'grid',
    gridTemplateColumns: 'minmax(120px, 160px) 1fr',
    columnGap: 16,
    alignItems: 'center'
  },
  rowLabel: {
    fontSize: 13,
    fontWeight: 500,
    color: token.colorText,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '8px 8px 8px 0',
    borderBottom: `1px solid ${token.colorSplit}`
  },
  rowValue: {
    padding: '8px 0',
    borderBottom: `1px solid ${token.colorSplit}`,
    minWidth: 0
  },
  rowLast: {
    borderBottom: 'none !important'
  },
  itemTag: {
    marginInlineEnd: 0,
    fontSize: 12
  }
}))
